// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1783575951249
      var cssReload = require("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./scss/main.scss
// module id = 1321
// module chunks = 58